/* eslint-disable react/prop-types */

import { useEffect, useState } from "react";
import Button from "../../../shared/v2/Button";
import Dropdown from "../../../shared/v2/Dropdown";
import { AngleDownSolidV6 } from "../../../shared/v2/Icomoon";

const orderDirection = (sortedBy) =>
  // assumes 'x' and 'x_desc' as the template
  sortedBy.slice(-4) === "desc" ? "desc" : "asc";
const orderParam = (sortedBy) => (orderDirection(sortedBy) === "desc" ? sortedBy.slice(0, -5) : sortedBy);

// Commented out items are the ones with no clear definition yet
const paramOptions = {
  address: {
    value: "address",
    label: "Address / Title",
  },
  agent: {
    value: "agent",
    label: "Agent",
  },
  close_date: {
    value: "close_date",
    label: "Close Date",
  },
  close_price: {
    value: "close_price",
    label: "Close Price",
  },
  date_canceled: {
    value: "date_canceled",
    label: "Date Canceled",
  },
  date_listed: {
    value: "date_listed",
    label: "Date Listed",
  },
  dom: {
    value: "dom",
    label: "DOM",
  },
  expiration_date: {
    value: "expiration_date",
    label: "Expiration",
  },
  gross_commission: {
    value: "gross_commission",
    label: "GCI",
  },
  last_updated: {
    value: "last_updated",
    label: "Last Updated",
  },
  listing_price: {
    value: "listing_price",
    label: "Listing Price",
  },
  // mls: {
  //   value: "mls",
  //   label: "MLS#",
  // },
  source: {
    value: "source",
    label: "Source",
  },
  type: {
    value: "type",
    label: "Type",
  },
};

export const paramOptionsArray = Object.keys(paramOptions)
  .sort()
  .map((key) => paramOptions[key]);
const directionOptionsArray = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

const Ordering = ({ param, direction }) => ({
  param,
  direction: direction || "asc",
  string: `${param}${direction === "desc" ? "_desc" : ""}`,
});

const orderFromString = (string) =>
  Ordering({
    param: orderParam(string),
    direction: orderDirection(string),
  });

const SortingMenu = ({ order, setOrder }) => {
  const [opened, setOpened] = useState(false);

  const originalOrder = orderFromString(order);
  const [presentedOrder, setPresentedOrderOrder] = useState(orderFromString(order));
  useEffect(() => {
    setPresentedOrderOrder(orderFromString(order));
    setOpened(false);
  }, [order]);

  const onOrderChange = (property, value) => {
    setPresentedOrderOrder(Ordering({ ...presentedOrder, [property]: value }));
  };

  return (
    <div className="tw-relative">
      <Button
        className="tw-flex tw-items-center tw-gap-[4px]"
        schema="secondary"
        size="small"
        onClick={() => setOpened(!opened)}
      >
        <span className="tw-inline-flex tw-items-center">
          SORT BY: {paramOptions[originalOrder.param]?.label}
        </span>
        <AngleDownSolidV6 size="s" />
      </Button>

      {opened && (
        <>
          <div className="tw-absolute tw-flex tw-items-center tw-right-0 tw-top-32px tw-flex-row tw-h-[68px] tw-p-16px tw-z-50 tw-bg-white tw-shadow-modal">
            <div className="tw-mr-8px tw-w-[200px]">
              <Dropdown
                isSearchable
                isClearable={false}
                menuShouldComeToFront
                options={paramOptionsArray}
                value={paramOptions[presentedOrder.param]}
                onChange={(o) => onOrderChange("param", o?.value || presentedOrder.param)}
              />
            </div>

            <div className="tw-mr-8px tw-w-[150px]">
              <Dropdown
                isSearchable={false}
                isClearable={false}
                menuShouldComeToFront
                options={directionOptionsArray}
                value={directionOptionsArray.find((o) => o.value === presentedOrder.direction)}
                onChange={(o) => onOrderChange("direction", o?.value || presentedOrder.direction)}
              />
            </div>

            <Button onClick={() => setOrder(presentedOrder.string)}>Save</Button>
          </div>
          <div
            role="presentation"
            className="tw-fixed tw-z-40 tw-inset-0 tw-bg-transparent"
            onClick={() => setOpened(false)}
          />
        </>
      )}
    </div>
  );
};

export default SortingMenu;
